import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useDatabaseChartsDataContext } from './hooks/useDatabaseChartsDataContext';

export const TotalOfFamiliesPerYearOfUpdate = () => {
    const { chartData } = useDatabaseChartsDataContext();

    return (
        <SimpleBars
            title={'Total de Famílias por Ano de Atualização'}
            horizontal={false}
            subtitles={
                chartData?.familiesUpdate?.map((item) => item.description) || []
            }
            values={chartData?.familiesUpdate?.map((item) => item.total  ||  0) || []}
            className='aligned-container'
        />
    );
};
